module.exports = __webpack_public_path__ + "img/mapBg.3a5bf8b8.png";